import './ProfileNavbar.css';
import React, { useState, useEffect, useRef } from 'react';

const ProfileNavbar = () => {
    const bearerToken = localStorage.getItem('bearerToken');
    // if (bearerToken === '' || bearerToken === undefined || bearerToken === null)
    //     window.location.href = '/';
    const [isEmployeeDropdownVisible, setIsEmployeeDropdownVisible] = useState(false);
    const [isAccountDropdownVisible, setIsAccountDropdownVisible] = useState(false);
    const [subOrdinates, setSubObdinates] = useState([]);
    const [policies, setPolicies] = useState([]);
    const employeeDropdownRef = useRef(null);
    const accountDropdownRef = useRef(null);
    const employeeBtnRef = useRef(null);
    const accountBtnRef = useRef(null);

    const [name, setName] = useState('Guest');
    const getSubordinates = async () => {
        // if (!bearerToken) {
        //     console.error('No token found');
        //     return;
        // }
        // try {
        //     const response = await fetch(`https://cbtflightmidapi.blueberry-travel.com/api/Employee/getSubordinates`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'Authorization': 'Bearer ' + bearerToken,
        //         }
        //     });
        //     if (!response.ok) {
        //         // if (response.status === 401) {
        //         //     localStorage.removeItem('bearerToken');
        //         //     localStorage.removeItem('policies');
        //         //     sessionStorage.removeItem('policies');
        //         //     localStorage.removeItem('user');
        //         //     sessionStorage.clear();
        //         //     window.location.href = '/';
        //         // }
        //         throw new Error(`Error ${response.status}: ${response.statusText}`);
        //     }
        //     const result = await response.json();
        //     setSubObdinates(result.data);
        //     //console.log(result);
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    const getPolicies = async (userId) => {
        // sessionStorage.removeItem('policies');
        // if (userId !== "Guest") {
        //     if (!bearerToken) {
        //         console.error('No token found');
        //         return;
        //     }
        //     try {
        //         const response = await fetch(`https://cbtflightmidapi.blueberry-travel.com/api/Employee/getSubordinatePolicy?userId=${userId}`, {
        //             method: 'POST',
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 'Authorization': 'Bearer ' + bearerToken,
        //             }
        //         });
        //         if (!response.ok) {
        //             // if (response.status === 401) {
        //             //     localStorage.removeItem('bearerToken');
        //             //     localStorage.removeItem('policies');
        //             //     sessionStorage.removeItem('policies');
        //             //     localStorage.removeItem('user');
        //             //     sessionStorage.clear();
        //             //     window.location.href = '/';
        //             // }
        //             throw new Error(`Error ${response.status}: ${response.statusText}`);
        //         }
        //         const result = await response.json();
        //         setPolicies(result.data);
        //         setIsEmployeeDropdownVisible(false);
        //         if (policy && policy[0]?.user) {
        //             setName(policy[0].user.fullName);
        //         }
        //         sessionStorage.setItem('policies', JSON.stringify(result.data));
        //     } catch (error) {
        //         console.error('Error fetching data:', error);
        //     }
        // }
        // else {
        //     setIsEmployeeDropdownVisible(false);
        //     setName('Guest');
        // }
        // if (window.location.pathname.includes('listing-page')) {
        //     window.location.reload();
        // }
    }

    useEffect(() => {
        if (!subOrdinates || subOrdinates.length === 0) {
            getSubordinates();
        }
    }, [subOrdinates]);

    const policy = JSON.parse(sessionStorage.getItem('policies'));

    useEffect(() => {
        if (policy && policy[0]?.user) {
            setName(policy[0].user.fullName);
        }
        
    }, [policy]);

    const handleLogout = () => {
        localStorage.removeItem('bearerToken');
        localStorage.removeItem('policies');
        sessionStorage.removeItem('policies');
        localStorage.removeItem('user');
        sessionStorage.clear();
        window.location.href = '/';
    };

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                employeeDropdownRef.current &&
                !employeeDropdownRef.current.contains(event.target) &&
                employeeBtnRef.current &&
                !employeeBtnRef.current.contains(event.target)
            ) {
                setIsEmployeeDropdownVisible(false);
            }
            if (
                accountDropdownRef.current &&
                !accountDropdownRef.current.contains(event.target) &&
                accountBtnRef.current &&
                !accountBtnRef.current.contains(event.target)
            ) {
                setIsAccountDropdownVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="mainNavbarContainer py-2">
            <div className="navbarBox">
                <a href="/home"><img src="./assets/logoBBT.png" alt="" className="logoBBTImg" /></a>

                <div className='navbarButtons'>
                    {/* Employees Dropdown */}
                    <div
                        className="profileBtn"
                        onClick={() => setIsEmployeeDropdownVisible(!isEmployeeDropdownVisible)}
                        ref={employeeBtnRef}
                    >
                        <p className='my-1'>{name}</p>
                        <img src="./assets/images/downArrowProfile.png" alt="" />
                    </div>
                    {isEmployeeDropdownVisible && subOrdinates && (
                        <div className="employeedropdown" ref={employeeDropdownRef}>
                            <div className="employeemenuItem" onClick={() => getPolicies('Guest')}>
                                <p className="mx-2 my-0">Guest</p>
                            </div>
                            {subOrdinates.map((s, index) => (
                                <div className="employeemenuItem" key={s.id} id={`${s.id}`} onClick={() => getPolicies(s.id)}>
                                    <p className="mx-2 my-0">{s.fullName}</p>
                                </div>))}
                        </div>
                    )}

                    {/* My Account Dropdown */}
                    <div
                        className="profileBtn"
                        onClick={() => setIsAccountDropdownVisible(!isAccountDropdownVisible)}
                        ref={accountBtnRef}
                    >
                        <img src="./assets/images/userIconProfile.png" alt="" className="profileLogo" />
                        <p className='my-1'>My Account</p>
                        <img src="./assets/images/downArrowProfile.png" alt="" />
                    </div>
                    {isAccountDropdownVisible && (
                        <div className="profiledropdownMenu" ref={accountDropdownRef}>
                            <div className="profilemenuItem">
                                <img src="./assets/images/userIcon.png" alt="Edit Profile" />
                                <a href="/profile">Edit Profile</a>
                            </div>
                            <div className="profilemenuItem">
                                <img src="./assets/images/calendarIcon.png" alt="Bookings" />
                                <a href="/bookings">Bookings</a>
                            </div>
                            <div className="profilemenuItem pb-4">
                                <img src="./assets/images/logoutIcon.png" alt="Log Out" />
                                <a onClick={handleLogout}>Log Out</a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileNavbar;
